import { push } from 'react-router-redux';
import actions from '../actions';
import { put, call, takeEvery, select } from 'redux-saga/effects'
import * as userApis from '../apis/userApis';
import { storeLocally, getFromLocalStorage, removeFromLocalStorage } from '../utils';

function* getUser(action) {
    try {
        const userDetails = yield call(userApis.getUserApi, action.userData);
        yield put({type: actions.GET_USER_SUCCESS, user: userDetails, token: action.userData.token});
    } catch(err) {
        console.log("Failed to get user ", err);
        yield put({type: actions.GET_USER_FAILED, err});
    }
}

function* signIn(action) {
    try {
        const user = yield call(userApis.signInApi, action.user);
        storeLocally('user', {
            id: user.user._id,
            token: user.token.token
        });
        yield put({ type: actions.SIGNIN_SUCCESS, user });
    } catch(err) {
        let errorMessage = "Failed to login";
        if(err.response.status === 401) {
            errorMessage = "Invalid credentials";
        }
        yield put({type: actions.SIGNIN_FAILED, errorMessage });
    }
}


function* logout() {
    removeFromLocalStorage('user');
    yield put(push('/login'));
}

function* goToLoginIfNotLoggedIn() {
    const state = yield select();
    if(!state.userAccount.token) {
        yield put(push('/login'));
    }
}

function* hideOverlay() {
    yield put({ type: actions.HIDE_OVERLAY });
}

function* goToHome() {
    yield put(push('/'));
}

function* markInitialDone() {
    const state = yield select();
    if(state.userAccount.initial) {
        yield put({ type: actions.INITIAL_GET_USER_DONE });
    }
}

const userSagas = [
    takeEvery(actions.GET_USER_REQUEST, getUser),
    takeEvery(actions.SIGNIN_REQUEST, signIn),
    takeEvery(actions.SIGNIN_SUCCESS, goToHome),
    takeEvery(actions.LOGOUT, logout),
    takeEvery(actions.INITIAL_GET_USER_DONE, goToLoginIfNotLoggedIn),
    takeEvery(actions.GET_USER_FAILED, markInitialDone),
    takeEvery(actions.GET_USER_SUCCESS, markInitialDone)
]
export default userSagas;


// WEBPACK FOOTER //
// ./src/sagas/userAccountSagas.js